module.exports = __webpack_public_path__ + "img/131.d80db5d.png";